import {
    SHOW_SAVE_GRID_VIEW,
    HIDE_SAVE_GRID_VIEW,
    SAVE_GRID_VIEW_REQUEST,
    SAVE_GRID_VIEW_SUCCESS,
    SAVE_GRID_VIEW_FAIL,
} from '../constants/action-types';

const initialState = {
    isGridViewSaving: false,
    isGridViewPopupVisible: false,

    popupMode: 'create',
    selectedView: {},

    error: '',
};

const customViewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SAVE_GRID_VIEW:
            return {
                ...state,
                isGridViewPopupVisible: true,
                mode: action.payload.mode,
                selectedView: action.payload.data,
            };
        case HIDE_SAVE_GRID_VIEW:
            return {
                ...initialState,
                isGridViewPopupVisible: false,
            };
        case SAVE_GRID_VIEW_REQUEST:
            return {
                ...state,
                isGridViewSaving: true,
            };
        case SAVE_GRID_VIEW_SUCCESS:
            return {
                ...state,
                isGridViewSaving: false,
            };
        case SAVE_GRID_VIEW_FAIL:
            return {
                ...state,
                isGridViewSaving: false,
                error: action.error || '',
            };
        default:
            return state;
    }
};

export default customViewsReducer;



// WEBPACK FOOTER //
// ./source/reducers/customViews.js